// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"214":"bb1eb484","663":"c1c486d5","986":"c6e4a1c9"}[chunkId] + ".chunk.js";
};